module.exports = __webpack_public_path__ + "img/homeVideo.da02527.png";